var map = {
	"./spid-ico-circle-bb.png": 199,
	"./spid-ico-circle-bb.svg": 315,
	"./spid-idp-arubaid.png": 316,
	"./spid-idp-arubaid.svg": 317,
	"./spid-idp-infocertid.png": 318,
	"./spid-idp-infocertid.svg": 319,
	"./spid-idp-intesaid.png": 320,
	"./spid-idp-intesaid.svg": 321,
	"./spid-idp-lepidaid.png": 322,
	"./spid-idp-lepidaid.svg": 323,
	"./spid-idp-namirialid.png": 324,
	"./spid-idp-namirialid.svg": 325,
	"./spid-idp-posteid.png": 326,
	"./spid-idp-posteid.svg": 327,
	"./spid-idp-sielteid.png": 328,
	"./spid-idp-sielteid.svg": 329,
	"./spid-idp-spiditalia.png": 330,
	"./spid-idp-spiditalia.svg": 331,
	"./spid-idp-timid.png": 332,
	"./spid-idp-timid.svg": 333
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 314;